import React from 'react';

export default function Cash({ className, viewBox = '0 0 20 20' }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg className={className} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Cash">
        <path
          id="Icon"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4 4.5C2.89543 4.5 2 5.39543 2 6.5V10.5C2 11.6046 2.89543 12.5 4 12.5L4 6.5H14C14 5.39543 13.1046 4.5 12 4.5H4ZM6 10.5C6 9.39543 6.89543 8.5 8 8.5H16C17.1046 8.5 18 9.39543 18 10.5V14.5C18 15.6046 17.1046 16.5 16 16.5H8C6.89543 16.5 6 15.6046 6 14.5V10.5ZM12 14.5C13.1046 14.5 14 13.6046 14 12.5C14 11.3954 13.1046 10.5 12 10.5C10.8954 10.5 10 11.3954 10 12.5C10 13.6046 10.8954 14.5 12 14.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
